export class EncryptionKey {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "arn",
            "baseName": "arn",
            "type": "string",
            "format": ""
        },
        {
            "name": "aliasName",
            "baseName": "aliasName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EncryptionKey.attributeTypeMap;
    }
    constructor() {
    }
}
